<template>
  <div class="agreement">
    <h1>{{info.name}}隐私协议</h1>
    <p>提示条款：</p>
    <p
      class="indent2EM agreecot"
    >您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，作为独立开发出{{info.name}}的{{info.compony}}（以下简称“{{info.abridge}}”或“我们”）制定本《隐私协议》（以下简称“本协议”）视为对用户隐私保护的许诺，并提醒您：</p>
    <p class="indent2EM agreecot">
      需要特别说明的是，
      <b
        class="underline"
      >本协议仅适用于{{info.name}}产品及服务，不适用于其他第三方向您提供的服务。在使用{{info.name}}产品服务前，请您务必仔细阅读并透彻理解本协议，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。不满18周岁的未成年人请在监护人陪同下使用本软件。您的使用行为即视为对本协议的充分理解并同意。</b> 如对本协议内容有任何疑问、意见或建议，您可通过产品提供的各种联系方式与我们联系。
    </p>
    <div class="agreecot">
      <p class="agreecot">第一部分 定义</p>
      <p>
        <b>{{info.name}}：</b>
        指{{info.name}}{{info.pro}}。
      </p>
      <p>
        <b>个人信息：</b>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      </p>
      <p>
        <b>个人敏感信息：</b>指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等个人信息（我们将在本协议中对具体个人敏感信息以
        <b>粗体</b>、
        <b>划线</b>
        等方式进行显著标识）。
      </p>
    </div>
    <div class="agreecot">
      <p class="agreecot">第二部分 隐私协议</p>
      <p class="agreecot">本隐私协议部分将帮助您了解一下内容：</p>
      <p>一、我们拥有的权限及对您个人信息的收集使用</p>
      <p>二、我们如何保护和管理您的信息</p>
      <p>三、您的个人信息如何在全球范围内转移</p>
      <p>四、本隐私协议如何更新</p>
      <p>五、如何联系我们</p>
    </div>
    <h2>一、我们拥有的权限及对您个人信息的收集使用</h2>
    <p class="indent2EM">
      我们仅会在合法、正当、必要的前提下收集、使用您的信息，在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用您的个人信息的场景仅包括：
      <b
        class="underline"
      >为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要信息。如您拒绝提供相应的信息，您将无法正常使用我们的产品及/或服务。</b>
    </p>
    <div class="agreecot">
      <p class="indent2EM">（一）您充分理解并同意继续使用本软件的服务，本软件会获取您如下权限：</p>
      <p>
        1.获取
        <b class="underline">相册读写权限</b>，此权限用于您上传照片制作证件照；
      </p>
      <p>
        2.获取
        <b class="underline">相机权限</b>，此权限用于您拍摄照片制作证件照；
      </p>
      <p>
        3.允许应用
        <b class="underline">读取存储卡中的内容</b> ，此权限用于获取图片制作证件照；
      </p>
      <p>
        4.允许应用
        <b class="underline">修改或删除存储卡中的内容</b> ，此权限用于保存证件照功能；
      </p>
      <p>
        5.允许应用
        <b class="underline">访问设备的电话</b> 功能，此权限可让应用确定本机号码是否正处于通话状态以及拨打号码，用于售后客服；
      </p>
      <p>
        6.获取
        <b class="underline">您登录的第三方账号的Uid</b>，此权限用于需要账户登录之后才能使用的服务，我们可能会根据您提供的相关信息进行校验您的身份，确保我们是在为您本人提供服务。需要确认您身份的场景包括使用优惠券功能、团体收照片功能；
      </p>
      <p>
        7.获取
        <b class="underline">您的设备相关信息，包括设备型号、操作系统版本、用户来源省市。这些单一信息是无法识别特定自然人身份的信息</b>，此权限主要用于用户反馈功能、在线客服功能，目的在于售后服务，及时有效的定位您反馈的问题并解决；
      </p>
      <p>
        8.获取
        <b class="underline">您的邮箱信息</b>，主要用于保存电子照的发送到邮箱保存方式（您的邮箱只保留7天，7天后删除）；
      </p>
      <p>
        9.获取
        <b class="underline">您的姓名、收件地址、手机号</b>，主要用于您使用冲印照片邮寄功能和向我们反馈问题或提出建议时，及时联系与处理；
      </p>
      <p>
        10.获取
        <b class="underline">您的人脸图像信息</b>，主要用于您使用照片拍摄、证件照制作、证件照片环境检测功能时判断您是否可以制作合格的证件照；
      </p>
    </div>
    <div class="agreecot">
      <p>
        （二）
        <b>征得授权的例外</b>
      </p>
      <p>您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
      <p>
        <b>1、与国家安全、国防安全有关的；</b>
      </p>
      <p>
        <b>2、与公共安全、公共卫生、重大公共利益相关的；</b>
      </p>
      <p>
        <b>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</b>
      </p>
      <p>
        <b>4、出于维护您或其他人的生命、财产等重大合法权益但又很难取得本人同意的；</b>
      </p>
      <p>
        <b>5、您自行向社会公众公开的个人信息；</b>
      </p>
      <p>
        <b>6、从合法公开披露的信息中收集个人信息</b> 的，如合法的新闻报告、政府信息公开等渠道；
      </p>
      <p>
        <b>7、根据您签订和履行相关协议或其他书面文书所必需的；</b>
      </p>
      <p>
        <b>8、用于维护所提供的产品及/或服务的安全稳定运行所必需的；</b>
      </p>
      <p>
        <b>9、为合法的新闻报道所必需的；</b>
      </p>
      <p>
        10、法律法规规定的
        <b>其他</b> 情形。
      </p>
    </div>
    <div class="agreecot">
      <p>（三）其他</p>
      <p>
        1、
        <b
          class="underline"
        >若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息前，请您确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需要在提供前征得对应儿童监护人的同意。</b>
      </p>
      <p>
        2、
        <b
          class="underline"
        >若我们将信息用于本协议未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的信息，均会事先得到您的同意。</b>
      </p>
      <p>
        3、
        <b
          class="underline"
        >建立专业安全团队会对您的个人信息（包括直接和间接的方式获取的信息）会进行安全加固（包括敏感信息报备、敏感信息加密存储、定期清除等），同时对于间接获取的个人信息，我们会对其来源进行合法性确认。</b>
      </p>
    </div>
    <h2>二、我们如何保护和管理您的个人信息</h2>
    <div class="agreecot">
      <p
        class="indent2EM"
      >尊重个人隐私是{{info.abridge}}的责任，当您确认并同意本协议使用我们的产品或服务时，为了保护您的个人隐私，{{info.abridge}}采取以下方式对您的个人信息进行保护和管理：</p>
      <p class="indent2EM">
        1、
        <b
          class="underline"
        >我们已采取符合业内标准、合理可行的安全防护措施保护您的个人信息，防止个人信息遭到未经授权访问、公开披露、使用、修改。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息;我们会采取SSL的方式在数据交换时进行加密保护；我们也会对相应的网址采取https的安全浏览方式；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</b>
      </p>
      <p class="indent2EM">
        2、
        <b class="underline">我们已经按照网络安全等级保护三级的要求完成测试要求并取得备案。</b>
      </p>
      <p class="indent2EM">
        3、
        <b
          class="underline"
        >我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本协议所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起三年。《中华人民共和国网络安全法》要求留存相关的网络日志不少于六个月。</b>
      </p>
      <p class="indent2EM">
        4、
        <b
          class="underline"
        >我们对您的个人敏感信息（您提交的证件照图片）采取了短暂保留期。对您制作好的电子证件照将会在您支付成功之日起7天内，保留在App内以供您下载（在此期间您也可以主动选择删除），7天后照片将会自动删除；冲印订单将会在您支付成功之日起保留30天（在此期间您也可以主动选择删除），30天后自动删除订单中包含的图片信息。</b>
      </p>
      <p class="indent2EM">
        5、
        <b
          class="underline"
        >{{info.abridge}}在未经用户授权时不得向第三方公开、编辑或透露用户个人资料的内容，但由于政府要求、法律协议需要等原因除外。在用户发送信息的过程中和本公司收到信息后，本公司将遵守行业通用的标准来保护用户的私人信息。</b>
      </p>
      <p class="indent2EM">
        6、
        <b class="underline">当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</b>
      </p>
    </div>
    <h2>三、您的个人信息如何在全球范围内移动</h2>
    <p class="indent2EM">
      我们在中华人民共和国
      <b class="underline">境内运营</b>中收集和产生的个人信息，
      <b class="underline">存储在中国境内</b>。
    </p>
    <h2>四、本隐私协议如何更新</h2>
    <p class="indent2EM">我们的隐私协议可能会发生变更。</p>
    <p class="indent2EM">未经您明确同意，我们不会限制您按照隐私协议所应享有的权利。我们会在专门页面上发布对隐私协议所做的任何变更。</p>
    <p class="indent2EM">
      对于重大变更，我们还会提供更为显著的通知（包括
      <b class="underline">客户端公示、页面交互、网页提示、弹窗、短信</b> 等）。
    </p>
    <p class="indent2EM">本隐私协议所指的重大变更包括但不限于：</p>
    <p class="indent2EM">
      1、我们的
      <b>服务模式</b>发生重大变化。如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等；
    </p>
    <p class="indent2EM">
      2、我们在
      <b>控制权</b>等方面发生重大变化。如并购重组等引起的信息控制者变更等；
    </p>
    <p class="indent2EM">
      3、您参与的
      <b>个人信息处理方面的权利及其行使方式</b>发生重大变化；
    </p>
    <p class="indent2EM">
      4、我们负责个人信息安全的
      <b>责任部门、联络方式及其投诉渠道</b>发生相关变化；
    </p>
    <p class="indent2EM">
      5、
      <b>个人信息安全影响评估报告</b>表明存在高风险。
    </p>
    <h2>五、如何联系我们</h2>
    <div class="agreecot">
      <p class="indent2EM">您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：</p>
      <p class="indent2EM">
        1、如对本协议内容有任何疑问、意见或建议，您可以通过{{info.name}}的
        <b class="underline">在线客服</b> 与我们联系；
      </p>
      <p class="indent2EM">
        2、我们还设置了个人信息保护专职部门，您可以通过
        <a href="mailto:idphoto@venpoo.com" class="underline">
          <b>邮箱idphoto@venpoo.com</b>
        </a>或
        <a href="tel:18020506879" class="underline">
          <b>电话18020506879</b>
        </a>与其联系。
      </p>
    </div>
    <p class="agreecot txtright">最近更新日期：2020年5月26日</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { agreement } from "@/utils/utils.js";
export default {
  data() {
    return {
      info: {}
    };
  },
  computed: {
    ...mapState(["platformInfo"])
  },
  created() {
    let appid = this.$route.query.appid || this.platformInfo.appId;
    let obj = agreement(appid) || {};
    this.info = obj;
  }
};
</script>

<style scoped>
.agreement {
  font-size: 0.16rem;
  border: 0.1rem solid #f1f1f1;
  background-color: white;
  padding: 0.2rem;
}
h1 {
  font-size: 0.2rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #ddd;
  margin-bottom: 0.2rem;
}
h2 {
  font-size: 0.2rem;
  margin: 0.15rem 0;
}
a {
  color: coral;
}
.agreecot {
  font-size: 0.16rem;
  margin-bottom: 0.15rem;
  letter-spacing: 0.02rem;
}
.txtright {
  text-align: right;
}
.indent2EM {
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
</style>
